import { AwardingClient } from "@/utils/EvoClient";
import deserializer from "@/utils/EvoClient/deserializer";
import { Lock } from "@/model/Lock";
import UrlBuilder from "../urlBuilder";

// prettier-ignore
const ENDPOINT = (awardUnitId: string) => `award-units/${awardUnitId}`;

export default async function getAwardUnitLock(
  awardUnitId: string
): Promise<Lock> {
  const result = await AwardingClient.get(
    UrlBuilder.fromBaseUrl(ENDPOINT(awardUnitId))
      .addLockQuery("awardUnit")
      .toString()
  );
  return deserializer.deserialize(result.data);
}
